import { Routes, Route } from "react-router-dom";
import Login from "./components/login";
import Forgotpassword from "./components/forgotpassword";
import Resetpassword from "./components/resetpassword";
import Registration from "./components/registration";
import Completeprofile from "./components/completeprofile";
// import User from "./components/user";
import Mostvisitedplace from "./components/mostvisitedplace";
import Countries from "./components/countries";
import Tripdetails from "./components/tripdetails";
import States from "./components/states";
import Cities from "./components/cities";
import Triplist from "./components/triplist";
import Languageinterface from "./components/languageinterface"
//import Ports from "./components/ports";
// import Interests from "./components/interests"
import MainLayout from "./components/mainlayout";
import { ConfigProvider } from "antd";
import Authorization from "./components/authorization";
import GoogleRedirect from "./components/googleredirect";
import FacebookRedirect from "./components/facebookredirect";
import DownloadApplication from "./components/downloadapplication";
import AgentDocument from "./components/agentdocument";
import Attendants from "./components/attendants";
import Traveller from "./components/traveller";
import GeneralSetting from "./components/generalsetting";
import Chats from "./components/chats";
import { useState, useEffect } from "react";
import { eventEmitter } from "./helpers/eventemitter";
import Commissions from "./components/refercommissionsummary";
import WithdrawalHistory from "./components/referpaymenthistory";
import AppVersion from "./components/appversion";
import ReferCommissionAndDiscountHistory from "./components/refercommisionanddiscounthistory";
import AttendantsEarningPaymentHistory from "./components/attendantsearningpaymenthistory";
import Finance from "./components/finance";
import AdminMessages from "./components/adminmessages";
import HotelAndAirbnb from "./components/hotelandairbnb";
import ReferCode from "./components/refercode";
import AvailableAttendants from "./components/availableattendants";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./components/NotFound";
import AdminUsers from "./components/adminusers";
import ActivityLogs from "./components/activitylogs";
import Dashboard from "./components/dashboard";
import TravellerDashboard from "./components/traveller-dashboard";
import MyTrips from "./components/my-trips";
import TravellerProfile from "./components/traveller-profile";
import TravellerLayout from "./components/traveller-layout";
import AiTripAgent from "./components/ai-trip-agent";
import TripMedia from "./components/tripmedia";
function App() {

  const [isClickable, setIsClickable] = useState(false);

  useEffect(() => {
    const handleClickableChange = (newValue: boolean) => {
      setIsClickable(newValue);
    };
    eventEmitter.on("clickableChange", handleClickableChange);

    return () => {
      eventEmitter.off("clickableChange", handleClickableChange);
    };

  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Jost,Kalam"
        }
      }}
    >
      <div className={`App ${isClickable ? "disable-clicks" : ""}`}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/NotFound" element={<NotFound />} />
          <Route path="forgotpassword" element={<Forgotpassword />} />
          <Route path="resetpassword" element={<Resetpassword />} />
          <Route path="authorization" element={<Authorization />} />
          <Route path="registration" element={<Registration />} />
          <Route path="auth/google" element={<GoogleRedirect />} />
          <Route path="auth/facebook" element={<FacebookRedirect />} />
          <Route path="complete" element={<DownloadApplication />} />
          <Route path="completeprofile" element={<Completeprofile />} />
          <Route path="agentdocument" element={<AgentDocument />} />
          <Route path="dashboard" element={<ProtectedRoute module="DASHBOARD" action="VIEW"><MainLayout><Dashboard /></MainLayout></ProtectedRoute>} />
          {/* Traveller portal routes */}
          <Route path="my-dashboard" element={<TravellerLayout><TravellerDashboard /></TravellerLayout>} />
          <Route path="my-trips" element={<TravellerLayout><MyTrips /></TravellerLayout>} />
          <Route path="my-profile" element={<TravellerLayout><TravellerProfile /></TravellerLayout>} />
          <Route path="my-assistant" element={<TravellerLayout><AiTripAgent /></TravellerLayout>} />
          <Route path="attendants" element={<ProtectedRoute module="ATTENDANTS" action="VIEW"><MainLayout><Attendants /></MainLayout> </ProtectedRoute>} />
          <Route path="travellers" element={<ProtectedRoute module="TRAVELLERS" action="VIEW"><MainLayout><Traveller /></MainLayout></ProtectedRoute>} />
          <Route path="adminusers" element={<ProtectedRoute module="ADMIN_USERS" action="VIEW"><MainLayout><AdminUsers /></MainLayout></ProtectedRoute>} />
          <Route path="mostvisitedplaces" element={<ProtectedRoute module="MOST_VISITED_PLACES" action="VIEW"><MainLayout><Mostvisitedplace /></MainLayout></ProtectedRoute>} />
          <Route path="countries" element={<ProtectedRoute module="COUNTRIES" action="VIEW"><MainLayout><Countries /></MainLayout></ProtectedRoute>} />
          <Route path="states" element={<ProtectedRoute module="STATES" action="VIEW"><MainLayout><States /></MainLayout></ProtectedRoute>} />
          <Route path="cities" element={<ProtectedRoute module="CITIES" action="VIEW"><MainLayout><Cities /></MainLayout></ProtectedRoute>} />
          <Route path="languageinterface" element={<ProtectedRoute module="LANGUAGE_INTERFACE" action="VIEW"><MainLayout><Languageinterface /></MainLayout></ProtectedRoute>} />
          <Route path="trips" element={<ProtectedRoute module="TRIPS" action="VIEW"><MainLayout><Triplist /></MainLayout></ProtectedRoute>} />
          <Route path="settings" element={<ProtectedRoute module="SETTINGS" action="VIEW"><MainLayout><GeneralSetting /></MainLayout></ProtectedRoute>} />
          <Route path="chats" element={<ProtectedRoute module="CHATS" action="VIEW"><MainLayout><Chats /></MainLayout></ProtectedRoute>} />
          <Route path="trips/:id/:scheduleId" element={<ProtectedRoute module="TRIPS" action="VIEW"><MainLayout><Tripdetails /></MainLayout></ProtectedRoute>} />
          <Route path="refer-commission-and-discount-history" element={<ProtectedRoute module="REFERRAL_DISCOUNT" action="VIEW"><MainLayout><ReferCommissionAndDiscountHistory /></MainLayout></ProtectedRoute>} />
          <Route path="refer-commission-summary" element={<ProtectedRoute module="COMMISSION" action="VIEW"><MainLayout><Commissions /></MainLayout></ProtectedRoute>} />
          <Route path="refer-payment-history" element={<ProtectedRoute module="REFERRAL_PAYMENT" action="VIEW"><MainLayout><WithdrawalHistory /></MainLayout></ProtectedRoute>} />
          <Route path="attendants-earning-payment-history" element={<ProtectedRoute module="ATTENDANTS_EARNING" action="VIEW"><MainLayout><AttendantsEarningPaymentHistory /></MainLayout></ProtectedRoute>} />
          <Route path="appversion" element={<ProtectedRoute module="APP_VERSION" action="VIEW"><MainLayout><AppVersion /></MainLayout></ProtectedRoute>} />
          <Route path="finance" element={<ProtectedRoute module="FINANCE" action="VIEW"><MainLayout><Finance /></MainLayout></ProtectedRoute>} />
          <Route path="adminmessages" element={<ProtectedRoute module="ADMIN_MESSAGES" action="VIEW"><MainLayout><AdminMessages /></MainLayout></ProtectedRoute>} />
          <Route path="tripmedia" element={<ProtectedRoute module="TRIP_MEDIA" action="VIEW"><MainLayout><TripMedia /></MainLayout></ProtectedRoute>} />
          <Route path="hotel&airbnb" element={<ProtectedRoute module="HOTEL_AIRBNB" action="VIEW"><MainLayout><HotelAndAirbnb /></MainLayout></ProtectedRoute>} />
          <Route path="refercode" element={<ProtectedRoute module="REFERRAL_CODE" action="VIEW"><MainLayout>< ReferCode /></MainLayout></ProtectedRoute>} />
          <Route path="activitylogs" element={<ProtectedRoute module="ACTIVITY_LOGS" action="VIEW"><MainLayout><ActivityLogs /></MainLayout></ProtectedRoute>} />
          <Route path="availableattendants" element={<MainLayout><AvailableAttendants /></MainLayout>} />
          {/* <Route path="ports" element={<MainLayout><Ports /></MainLayout>} /> */}
          {/* <Route path="interests" element={<MainLayout><Interests /></MainLayout>} /> */}
          {/* <Route path="user" element={<MainLayout><User /></MainLayout>} /> */}
          {/* <Route path="forgotpassword" element={<Forgotpassword />} /> */}
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;